<template>
  <div class="em-tab">
    <ul class="tab-list">
      <li class="tab-li" v-for="(item, index) in tabItem"  @click="handelSwitch(index)">
        <span class="tab-text" :class="{active: index === actIndex}" v-html="item"></span>
      </li>
    </ul>
    <slot></slot>
  </div>
</template>
    <style>
    .em-tab
    {
      margin-top: 9.4rem
    }
    </style>
<script>
export default {
  name: 'tab',
  data() {
      return {
        actIndex: this.activedIndex || 0
      }
  },
  props: {
    tabItem:{
      type : Array ,
      default: ()=> ['选项一','选项二','选项三']
    }
  },
	methods: {
    handelSwitch(index){
      this.actIndex=index;
      this.$emit('click', index);
    }
	}
}
</script>



// WEBPACK FOOTER //
// src/components/financeCalendar/financeTab.vue